/*
 * @Author: sillyy
 * @Date: 2019-02-11 14:31:49
 * @LastEditors: sillyy
 * @LastEditTime: 2019-02-11 14:38:10
 * @Description: 本地环境-方法
 */
import { OForm } from '@/types/views/login'
class Local {
  setAccount(form: OForm) {
    return {
      username: 'admin@miaocode.com',
      password: '123456',
      captcha: '123456'
    }
  }
}
export default new Local()
